import * as auth from './auth/actions';
import * as theme from './theme/actions';
import * as noti from './noti/actions';

export default {
  auth,
  noti,
  theme,
};
